/**
 * 由于玩法信息数据多，又不会变更，因此单独放到一个节点，以免引起不必要的diff算法
 */
import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/lotteryTypes';
import * as PUSH_ACTION from '../constants/types/pushTypes'
import * as lotteryService from '../services/lotteryService.jsx'
import {stateStructure} from './_stateStructure.js'
import { CLIENT_SOURCE } from '../constants/config.js';
import $CACHE from '../helpers/cache'
import { disableMethodsByDynamic } from '../services/lotteryService.jsx';

const initialState = Immutable.fromJS( stateStructure.method );

export default function method( state = initialState, action ){
	let _state = state.toJS();

	switch (action.type) {

		// 初始化玩法信息
		case ACTION.INIT_METHODS:{
			// 玩法筛选
			_.forEach(action.methods, function(method, key){
				method = lotteryService.specialMethodFilter(method);
			})
			_state.staticLoadDone = true;
			window.METHODS.static = action.methods
			// 屏蔽不可用玩法
			disableMethodsByDynamic();
			return state.merge(_state);
		}
		// 设置当前窗口ID
		case ACTION.SET_WINDOWID:{
			_state.windows[action.data] = {
				submit: [],
				display: [],
				track_issue: null,
				current_issue: {},
				history_issue: [],
				trace:{}
			};
			return state.merge(_state);
		}
		case ACTION.SET_NO_BET_AUTH_ERROR:{
			_state.autheError = {
				message: action.message,
				status: action.status
			};
			window.METHODS.autheError = _state.autheError;
			return state.merge(_state);
		}
		// 从接口设置玩法动态区数据
		case ACTION.GET_DYNAMIC_METHOD_INFO:{
			_state.dynamicLoadDone = true;
			// 多返点时候特殊处理（返点按照区间范围显示）
			let dynamicMethods = _.filter(action.result.data, (item) => !item.prize_group || item.prize_group.length <=2);
			let multiPrizeMode = _.filter(action.result.data, (item) => item.prize_group && item.prize_group.length > 2);
			_.each(multiPrizeMode, function(prizeMode, index){
				const minMaxValues = _.chain(prizeMode.prize_group)
									  .map((item) => item.label.substring(3).split('-').map((it) => parseFloat(it)))
									  .map((item) => ({value: item[1], prize: item[0]}))
									  .groupBy('value')
									  .map((item, key) => ({value: key, max: _.maxBy(item, 'prize').prize, min: _.minBy(item, 'prize').prize}))
									  .orderBy('value', 'desc')
									  .value()
				// 使用最大最小值进行拼接
				const areaPrize = [
					{value: 1, label: `奖金 ${minMaxValues[0].min}~${minMaxValues[0].max} ${minMaxValues[0].value}%`},
					{value: 2, label: `奖金 ${minMaxValues[1].min}~${minMaxValues[1].max} ${minMaxValues[1].value}.0%`},
				]
				prizeMode.prize_group = areaPrize;
				prizeMode.areaPrize = true;
			})
			// 合并
			dynamicMethods = dynamicMethods.concat(multiPrizeMode);
			// 赋值
			window.METHODS.dynamic = dynamicMethods
			// 动态数据缓存
			$CACHE.put('method_dynamic', {data: dynamicMethods, userid: action.extend}, 30);
			disableMethodsByDynamic();
			return state.merge(_state);
		}
		// 从缓存设置玩法动态区数据
		case ACTION.GET_DYNAMIC_METHOD_INFO_FROM_CACHE:{
			var dynamicData = $CACHE.get('method_dynamic');
			// 没有值
			if (!dynamicData) {
				return state;
			}
			// 有值但是userid不一致
			if (dynamicData.data.userid != action.userid) {
				$CACHE.remove('method_dynamic');
				return state;
			}
			window.METHODS.dynamic = dynamicData.data.data;
			// 屏蔽不可用玩法
			disableMethodsByDynamic();
			_state.dynamicLoadDone = true;
			return state.merge(_state);
		}
		// 设置当前玩法区
		case ACTION.SET_WINDOW_METHOD:{
			// _state.windows[action.windowId] = {};
			_state.windows[action.windowId] = {
				error: null,
				flag: action.data.flag,
				id: action.data.id,
				submit: [],
				display: [],
				track_issue: null,
				current_issue: {},
				history_issue: [],
				request: {
					lotteryid:  action.data.id,
					play_source: CLIENT_SOURCE[window.CLIENT_INFOS.source],
					curmid: action.data.curmid
				},
				trace: {
					lt_trace_stop: 'no',
					lt_trace_times_margin: 1,
					lt_trace_margin: 50,
					lt_trace_times_same: 1,
					lt_trace_diff: 1,
					lt_trace_times_diff: 2,
					lt_trace_count_input: 10,
					lt_trace_money: 0,
					lt_trace_issues: {}
				}
			}
			// 秒秒彩差异化数据
			if (action.data.id == 23) {
				_state.windows[action.windowId].trace = {};
				// 连续开奖次数
				_state.windows[action.windowId].times = 1;
				// 中奖停止
				_state.windows[action.windowId].stopWhenWin = true;
				// 正在开奖
				_state.windows[action.windowId].beting = false;
				// 连续开奖情况
				_state.windows[action.windowId].excute = [];
				// 历史奖期
				_state.windows[action.windowId].current_issue.history = {
					issue: '000000-000',
					code: '00000',
					original_code: '00000',
					split_code: [
						'-','-','-','-','-'
					]
				}
				
			}
			window.METHODS.windows = window.METHODS.windows || {};
			window.METHODS.windows[action.windowId] = action.data;
			return state.merge(_state);
		}

		// 打开关闭动画 (废弃，交由base->config控制)
		// case ACTION.TOGGLE_DISPLAY_ANIMATION:{
		// 	_state.windows[action.windowId].show_animation = action.status;
		// 	return state.merge(_state);
		// }

		// 设置追号信息
		case ACTION.SET_TRACK_INFO:{
			_state.windows[action.windowId].trace = action.trace;
			return state.merge(_state);
		}

		// 重置追号信息
		case ACTION.RESET_TRACK_INFO:{
			_state.windows[action.windowId].trace = {
				lt_trace_stop: 'yes',
				lt_trace_times_margin: 1,
				lt_trace_margin: 50,
				lt_trace_times_same: 1,
				lt_trace_diff: 1,
				lt_trace_times_diff: 2,
				lt_trace_count_input: 10,
				lt_trace_money: null,
				lt_trace_issues: {}
			}
			return state.merge(_state);
		}

		// 重置投注页信息
		case ACTION.RESET_LOTTERY_METHOD:{
			_state.windows[action.windowId] = {
				submit: [],
				display: [],
				track_issue: null
			};
		}
		
		// unmout的时候清理当前玩法
		case ACTION.CLEAR_WINDOW_METHOD:{
			delete _state.windows[action.windowId];
			if (window.METHODS.windows) {
				delete window.METHODS.windows[action.windowId];
			}
			return state.merge(_state);
		}

		// 添加投注到订单
		case ACTION.ADD_BET_TO_ORDER:{
			_state.windows[action.data.windowId].submit.push(action.data.submit);
			_state.windows[action.data.windowId].display.push(action.data.display);
			return state.merge(_state)
		}

		// 添加六合彩到订单
		case ACTION.ADD_BET_TO_ORDER_FOR_LHC:{
			const {submit, display} = _state.windows[action.data.windowId];
			_state.windows[action.data.windowId].submit = _.concat(submit, action.data.submit)
			_state.windows[action.data.windowId].display = _.concat(display, action.data.display)
			return state.merge(_state)
		}

		// 从订单中删除投注单
		case ACTION.REMOVE_BET_FROM_ORDER:{
			if (action.data.betId == null) {
				_state.windows[action.data.windowId].submit = [];
				_state.windows[action.data.windowId].display = [];
			}else{
				_state.windows[action.data.windowId].submit = _.filter(_state.windows[action.data.windowId].submit, (item) => item.id != action.data.betId);
				_state.windows[action.data.windowId].display = _.filter(_state.windows[action.data.windowId].display, (item) => item.id != action.data.betId);
			}
			// 秒秒彩设置连续开奖为1
			if (_state.windows[action.data.windowId].submit.length == 0) {
				_state.windows[action.data.windowId].times = 1;
			}
			return state.merge(_state)
		}

		// 从订单中删除单挑注单
		case ACTION.REMOVE_SOLOBET_FROM_ORDER:{
			_state.windows[action.data.windowId].submit = _.filter(_state.windows[action.data.windowId].submit, (item) => !item.solo);
			_state.windows[action.data.windowId].display = _.filter(_state.windows[action.data.windowId].display, (item) => !item.solo);
			return state.merge(_state)
		}

		// 获取当前彩种销售信息
		case ACTION.GET_CURRENT_ISSUE:{
			let extend = {
				countdown: null,
				interval: null
			};
			// 组件已经卸载
			if (!_state.windows[action.extend]) {
				return state;
			}
			// 如果不是当前彩种的销售信息，那么直接忽略
			if (action.origin.lotteryId != _state.windows[action.extend].id) {
				return state;
			}
			// 封装倒计时
			if (action.result.data && action.result.data.saleend) {
				extend = {
					countdown: new Date(action.result.data.saleend.replace(/-/g,'\/') + ' GMT+0800').getTime() / 1000 - window.serverTime,
					interval: (new Date(action.result.data.saleend.replace(/-/g,'\/') + ' GMT+0800').getTime() - new Date(action.result.data.salestart.replace(/-/g,'\/') + ' GMT+0800').getTime()) / 1000
				} 
			}
			_state.windows[action.extend].current_issue.countdown = extend.countdown;
			_state.windows[action.extend].current_issue.interval = extend.interval;
			_state.windows[action.extend].current_issue.current = action.result.data || {};
			return state.merge(_state)
		}

		// 获取当前可追号奖期
		case ACTION.GET_TRACK_ISSUES:{
			// 组件已经卸载
			if (!_state.windows[action.extend]) {
				return state;
			}
			// 如果不是当前彩种的销售信息，那么直接忽略
			if (action.origin.lotteryId != _state.windows[action.extend].id) {
				return state;
			}
			_state.windows[action.extend].track_issue = JSON.stringify(action.result.data);
			return state.merge(_state)
		}

		// 根据彩种ID获取历史开奖奖期
		case ACTION.GET_LOTTERY_HISTORY:{
			if (!action.extend) {
				return state;
			}
			// 组件已经卸载
			if (!_state.windows[action.extend]) {
				return state;
			}
			// 如果不是当前彩种的销售信息，那么直接忽略
			if (action.origin.lotteryId != _state.windows[action.extend].id) {
				return state;
			}
			_state.windows[action.extend].history_issue = action.result.data;
			// 更新当前奖期中最近一期开奖
			const defaultHistory = {
					issue: '000000-000',
					code: '00000',
					original_code: '00000',
					split_code: ['-','-','-','-','-']
				}
			_state.windows[action.extend].current_issue.history = action.result.data[0] || defaultHistory;
			return state.merge(_state)
		}

		// 设置彩种窗口错误信息
		case ACTION.SET_LOTTERY_ERRORS:{
			// 如果是秒秒彩，那么需要把模拟开奖设置成false
			// const lotteryFlag = _state.windows[action.windowId].flag;
			// if (lotteryFlag === 'mmc') {
			// 	_state.windows[action.windowId].simulating = true;
			// }
			if (action.lotteryId == _state.windows[action.windowId].id) {
				_state.windows[action.windowId].track_issue = [];
				_state.windows[action.windowId].error = action.message;
			}
			return state.merge(_state)
		}

		// 模拟开奖
		case ACTION.SIMULATED_NUMBER:{
			const code = action.result.data.number;
			// 组件已经卸载
			if (!_state.windows[action.extend]) {
				return state;
			}
			// 更新当前奖期的历史号码
			_state.windows[action.extend].current_issue.history.code = code;
			_state.windows[action.extend].current_issue.history.original_code = code;
			_state.windows[action.extend].current_issue.history.split_code = _.split(code, '');
			// 更新近期开奖历史号码
			_state.windows[action.extend].history_issue.unshift({
				issue: null,
				code: code,
				original_code: code,
				split_code: _.split(code, '')
			})
			// 如果超过10条则删除最后一条
			if (_state.windows[action.extend].history_issue.length > 25) {
				_state.windows[action.extend].history_issue = _.dropRight(_state.windows[action.extend].history_issue);
			}
			return state.merge(_state);
		}

		// 切换模拟开奖状态
		case ACTION.TOGGLE_SIMULAT_STATUS:{
			_state.windows[action.windowId].simulating = action.status;
			return state.merge(_state);
		}

		// 变更MMC投注状态
		case ACTION.CHANGE_MMC_BET_STATUS:{
			_state.windows[action.windowId].beting = action.status;
			if (action.status) {
				_state.windows[action.windowId].simulating = true;
			}
			return state.merge(_state);
		}

		// 秒秒彩投注
		case ACTION.MMC_LOTTERY_BET:{
			_state.windows[action.extend.windowId].simulating = false;
			const code = action.result.data.wcodes;
			const bonus = Number(action.result.data.bonus);
			// 更新当前奖期的历史号码
			_state.windows[action.extend.windowId].current_issue.history.code = code;
			_state.windows[action.extend.windowId].current_issue.history.original_code = code;
			_state.windows[action.extend.windowId].current_issue.history.split_code = _.split(code, '');
			// 更新近期开奖历史号码
			_state.windows[action.extend.windowId].history_issue.unshift({
				issue: null,
				code: code,
				original_code: code,
				split_code: _.split(code, '')
			})
			// 如果超过10条则删除最后一条
			if (_state.windows[action.extend.windowId].history_issue.length > 25) {
				_state.windows[action.extend.windowId].history_issue = _.dropRight(_state.windows[action.extend.windowId].history_issue);
			}
			// 更新连续执行情况
			_state.windows[action.extend.windowId].excute.push({
				times: action.extend.times,
				bonus: bonus
			});
			// 中奖
			if (bonus > 0) {
				//中奖停止的话，那么停止开奖
				if (_state.windows[action.extend.windowId].stopWhenWin) {
					_state.windows[action.extend.windowId].beting = false;
				}
			}
			return state.merge(_state);
		}
		// 清空秒秒彩投注执行情况array
		case ACTION.MMC_CLEAR_EXCUTE:{
			_state.windows[action.windowId].excute = [];
			return state.merge(_state);
		}

		// 切换秒秒彩中奖后停止状态
		case ACTION.MMC_TOGGLE_STOPWHENWIN:{
			_state.windows[action.windowId].stopWhenWin = action.status;
			return state.merge(_state);
		}

		// 秒秒彩变更连续开奖期数
		case ACTION.MMC_CHANGE_PLAYTIMES:{
			_state.windows[action.windowId].times = action.times;
			return state.merge(_state);
		}

		// 获取彩种投注的有效号码
		case ACTION.GET_VALID_NUMBER:{
			// 如果不是当前彩种的销售信息，那么直接忽略
			if (action.origin.lotteryId != _state.windows[action.extend].id) {
				return state;
			}
			_state.windows[action.extend].valid_codes = _.split(action.result.data.number_sets, ',');
			return state.merge(_state);
		}

		// 构造冷热遗漏号码
		case ACTION.MAKE_MISSCODE_RULE:{
			const { vaildCode, windowId } = action.extend;
			const historyIssues = action.result.data;
			// 组件已经卸载
			if (!_state.windows[action.extend.windowId]) {
				return state;
			}
			// 如果不是当前彩种的销售信息，那么直接忽略
			if (action.request.url.split('/')[2] != _state.windows[windowId].id) {
				return state;
			}
			_state.windows[windowId].missCodes = lotteryService.makeHistoryCodeNumbers(historyIssues, vaildCode);
			return state.merge(_state);
		}

		// 更新最新开奖记录
		case PUSH_ACTION.LIVE_ISSUE_DATA:{
			_.each(action.data, function(history, windowKey){
				// 被设置窗口 
				let { history_issue, current_issue } = _state.windows[windowKey]
				// 之前没有的话，那么构造一个新对象
				if(!_.find(history_issue, {issue: history.issue})){
					let hisIssue = {
						issue: history.issue,
						code: history.code,
						original_code:history.fullcode
					}
					hisIssue.split_code = _.split(history.code, ' ');
					if (hisIssue.split_code.length == 1) {
						hisIssue.split_code = _.split(hisIssue.split_code, '');
					}
					// 插入历史奖期顶端, 去掉最后一个
					history_issue.unshift(hisIssue);
					history_issue = _.dropRight(history_issue)
					// 当前历史奖期覆盖
					current_issue.history = hisIssue;
				}
			})
			return state.merge(_state);
		}

		// 注销用户
		case USER_ACTION.LOGOUT:{
			let _initState = initialState.toJS();
			// 静态数据不重复加载
			_initState.staticLoadDone = _state.staticLoadDone
			// 删除错误信息
			window.METHODS.autheError = null;
			return Immutable.fromJS( _initState );
		}
		// 添加投注到订单
		case ACTION.UPDATE_MODE_LOTTERY_ODER:{
			_.forEach(_state.windows[action.data.windowId].submit, function(item){
				if (item.id == action.data.id) {
			    item.mode = action.data.submit.mode;
			    item.rate = action.data.submit.rate;
			    item.money = parseFloat(action.data.display.money);
			  }
			})
			_.forEach(_state.windows[action.data.windowId].display, function(item){
				if (item.id == action.data.id) {
			    item.mode = action.data.display.mode;
			    item.rate = action.data.display.rate;
			    item.money = parseFloat(action.data.display.money);
			  }
			})
			return state.merge(_state)
		}
		case ACTION.UPDATE_TIMES_LOTTERY_ODER:{
			_.forEach(_state.windows[action.data.windowId].submit, function(item){
				if (item.id == action.data.id) {
			    item.times = Number(action.data.submit.times);
			    item.money = parseFloat(action.data.submit.money);
			  }
			})
			_.forEach(_state.windows[action.data.windowId].display, function(item){
				if (item.id == action.data.id) {
			    item.times = Number(action.data.display.times);
			    item.money = parseFloat(action.data.display.money);

			  }
			})
			return state.merge(_state)
		}
		// 当前彩种当前奖期结束后本地处理下一期数据
		case ACTION.NEXT_CURRENT_ISSUE:{
			// 组件已经卸载
			if (!_state.windows[action.windowId]) {
				return state;
			}
			// 如果用户在倒计时最后时刻切换彩种则忽略
			const lotteryId = action.lotteryId;
			if (lotteryId != _state.windows[action.windowId].id) {
				return state;
			}
			// 将当前奖期改为下一期
			let { current_issue, track_issue } = _state.windows[action.windowId];
			let track_issue_ob = JSON.parse(track_issue);
			let nextIssue = null;
			if (track_issue_ob && track_issue_ob.length > 1) {
				nextIssue = _.cloneDeep(track_issue_ob[1]);
				track_issue_ob = _.filter(track_issue_ob, (item, index) => index > 0)
			}
			// 当前奖期
			current_issue.current.issue = nextIssue.issue;
			current_issue.current.salestart = current_issue.current.saleend;
			current_issue.current.saleend = nextIssue.saleend;
			// 可追
			_state.windows[action.windowId].track_issue = JSON.stringify(track_issue_ob)

			return state.merge(_state)
		}
		// 推送彩种销售状态
		case PUSH_ACTION.LIVE_SALE_INFO:
		// 获取彩种销售情况
		case ACTION.GET_LOTTERY_SALEINFO:{
			// 从推送判断是否没有在售
			_.each(_state.windows, function(win){
				// 秒秒彩不需要同步当前在售情况
				if (!win.id || win.id == 23) {return state}
				const currentLottery = _.find(action.result.data, {lotteryid: Number(win.id)});
				if (currentLottery && !currentLottery.is_selling && !currentLottery.is_sale) {
					win.error = '当前没有销售';
				}
			})
			return state.merge(_state);
		}
    // 更新订单
    case ACTION.UPDATE_ORDER:{
      _.forEach(_state.windows[action.data.windowId].submit, function(item,index){
        item.money = action.data.submit[index].money
        item.times = action.data.submit[index].times
      })
      _.forEach(_state.windows[action.data.windowId].display, function(item,index){
        item.money = action.data.display[index].money
        item.times = action.data.display[index].times
      })
      return state.merge(_state)
    }
		default:
      		return state;
	}
}